import { handleActions } from 'redux-actions';
import { resourceStoreTypes, resourceUpserters } from '../core';

import * as actions from './achievementsActions';

const achievementsReducer = handleActions(
  {
    [actions.getAchievementsSuccess]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const ACHIEVEMENTS_REDUCER_KEY = 'achievementsStore';
export default achievementsReducer;
